import { getGameByGameIdEventsOptions } from "@aura-frontend/omnibus-az-client";
import { useQuery } from "@tanstack/react-query";

import { type GameSC } from "@/types/game";
import { isGameStateCorrectionTag } from "@/utils/gameEventFilters";

type UseGameEventsParams = {
  gameId?: string;
  enabled?: boolean;
};

export const useGameEvents = ({
  gameId,
  enabled = true,
}: UseGameEventsParams) => {
  const baseOptions = getGameByGameIdEventsOptions({
    path: { game_id: gameId ?? "" },
  });
  const query = useQuery({
    ...baseOptions,
    enabled: enabled && !!gameId,
    // Live game events  — keep tighter than the 5min global default so any
    // refocus/navigation during tagging picks up fresh events sooner.
    staleTime: 1 * 60 * 1000,
    select: (data) => ({
      ...data,
      events: data.events.filter((e) => !isGameStateCorrectionTag(e)),
    }),
  });

  return {
    events: query.data?.events ?? [],
    game: query.data?.game as GameSC | undefined,
    isLoading: query.isLoading,
    error: query.error as Error | null,
  };
};

export default useGameEvents;
